import { getBodyData } from '../../selectors';

export const cheaperOptionSelector = (state) => getBodyData(state).cheaperOption;
export const cheaperOptionTextSelector = (state) => cheaperOptionSelector(state).texts;
